import React from 'react';
import FilterList from '../../../components/user/location/locationFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const LocationListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

LocationListPage.propTypes = {};

export default LocationListPage;
